/* eslint-disable react/forbid-prop-types */
import React, { Component } from 'react';
import { Provider } from 'react-redux';
import PropTypes from 'prop-types';
import { ThemeProvider } from 'styled-components';
import { ThemeProvider as GCCThemeProvider, getTheme } from '@gcc/autobahn-components';
import Portal from '@gcc/pip-components/dist/Portal';
import EstimateModeHeader from '../components/CaptiveHeader/EstimateModeHeaderConnector';
import EstimateModeFooter from '../components/CaptiveFooter/EstimateModeFooterConnector';
import Loading from './LoadingConnector';
import GlobalErrorModal from './GlobalErrorModalConnector';
import config from '../helpers/config';
import { sites } from '../helpers/globalVariables';
import themes from '../themes';
import ModalProvider from './ModalProvider';

const globalStyles = '';

const theme = getTheme(config.siteId);

/* Note:
  Pulled ThemeProvider from GCC Autobahn Components, as the inner theme will have precendence
  of scope. Using Alert component that needed the theme object and slowly but surely we
  should start bringing over or making re usable components in estimate builder.
*/
export default class App extends Component {
  static propTypes = {
    store: PropTypes.object.isRequired,
    routes: PropTypes.object.isRequired,
  };

  shouldComponentUpdate = () => false;

  render = () => (
    <ThemeProvider theme={themes(config.siteId)}>
      <GCCThemeProvider globalStyles={globalStyles} theme={theme}>
        <ModalProvider>
          <Provider store={this.props.store}>
            <div>
              {config.siteId === sites.theHomeDepot &&
              <Portal node={document.getElementById('mounted-header')}>
                <EstimateModeHeader />
              </Portal>
            }
              <Loading />
              <GlobalErrorModal />
              <div className="App">{this.props.routes}</div>
              {config.siteId === sites.theHomeDepot &&
              <Portal node={document.getElementById('mounted-footer')}>
                <EstimateModeFooter />
                {/* Adds Qualtrics For Customer Feedback */}
                <div className="m-top-small" id="thd-feedback-link" />
              </Portal>
            }
            </div>
          </Provider>
        </ModalProvider>
      </GCCThemeProvider>
    </ThemeProvider>
  );
}
